import { Flex } from '@instructure/ui-flex'
import { Link } from '@instructure/ui-link'
import { Text } from '@instructure/ui-text'
import {IconInstructureLogo} from '../../../../mc-icons/svg'

const HELP_URL = '/help'
const TERMS_OF_SERVICE_URL = '/TOS'
const PRIVACY_POLICY_URL = '/privacy'
const INSTRUCTURE_URL = 'https://www.instructure.com/'

export const Footer = () => {
  return (
    <>
      <Flex as="div" justifyItems="center" margin="small none none none">
        <Flex.Item padding="x-small">
          <Text size="x-small">
            <Link href={HELP_URL} color="link-inverse">Help</Link>
          </Text>
        </Flex.Item>
        <Flex.Item padding="x-small">
          <Text size="x-small">
            <Link href={TERMS_OF_SERVICE_URL} color="link-inverse">Terms of Service</Link>
          </Text>
        </Flex.Item>
        <Flex.Item padding="x-small">
          <Text size="x-small">
            <Link href={PRIVACY_POLICY_URL} color="link-inverse">Privacy Policy</Link>
          </Text>
        </Flex.Item>
      </Flex>

      <Flex as="div" justifyItems="center" margin="small">
        <Flex.Item>
          <Link href={INSTRUCTURE_URL} color="link-inverse">
            <IconInstructureLogo width="110" height="16" color="primary-inverse" />
          </Link>
        </Flex.Item>
      </Flex>
    </>
  )
}